module.exports = __webpack_public_path__ + "img/new-cog-disguise-indicator.16dd0fbe.webp";